import React, { cloneElement } from 'react'
import classnames from 'classnames'

import { GridLayout, GridLayoutItem } from 'components/grid/GridLayout'
import { H2 } from 'components/heading/Heading'

import s from './NewsHero.module.scss'

const c = classnames.bind(s)

type Props = {
  image?: React.ReactElement
  date?: React.ReactElement
  title?: string
}

export const NewsHero = (props: Props) => {
  const { image, date, title } = props

  return (
    <div className={c(s.newsHero, { [s.hasImage]: !!image })}>
      <GridLayout>
        {image && (
          <GridLayoutItem
            className={s.newsHero__imageWrap}
            offset={{ desktop: 2 }}
            columns={{ desktop: 8 }}
          >
            {cloneElement(image, { className: s.newsHero__image })}
          </GridLayoutItem>
        )}
        <GridLayoutItem
          className={s.newsHero__date}
          offset={{ desktop: 3 }}
          columns={{ desktop: 6 }}
        >
          {date}
        </GridLayoutItem>
        <GridLayoutItem offset={{ desktop: 3 }} columns={{ desktop: 6 }}>
          <H2 as="h1" className={s.newsHero__title}>
            {title}
          </H2>
        </GridLayoutItem>
      </GridLayout>
    </div>
  )
}
